<template>
    <span
        class="nuxt-icon block"
        :class="iconSizeClass"
        aria-hidden="true"
    >
        <SpriteSymbol v-if="props.name" :name="(props.name as NuxtSvgSpriteSymbol)" />
    </span>
</template>

<script setup lang="ts">
import { reactive } from '#imports'
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-icon-sprite/runtime'

const props = withDefaults(defineProps<{
    name: string;
    size?: string;
}>(), {size: 'md'})

const isOAuthIcon = computed(() => ['google', 'apple', 'facebook'].includes(props.name))

const iconSizeClass = reactive({
    'w-3 h-3': props.size === 'xs',
    'w-4 h-4': props.size === 'sm',
    'w-5 h-5': props.size === 'md',
    'w-6 h-6': props.size === 'lg',
    'w-8 h-8': props.size === 'xl',
    'w-16 h-16': props.size === '2xl',
    'oauth-icon': isOAuthIcon.value,
})
</script>
